import { textpart } from './htmlUtils';

export const findModule = (program, moduleId) => (program && moduleId ? program.modules.reduce((p, c) => (c.id === moduleId ? c : p), null) : null);

export const findTask = (program, moduleId, taskId) => (
    program && moduleId && taskId
        ? program.modules.reduce((p, module) => (module.id === moduleId
            ? module.tasks.reduce((pt, task) => (task.id === taskId ? task : pt), null)
            : p), null)
        : null
);

const firstQuestionText = questions => (
    questions && questions.length > 0 ? textpart(questions[0].question) : null
);

const firstHeaderOrText = (htmlContent, length = 50) => {
    const doc = new DOMParser().parseFromString(htmlContent, 'text/html');
    const t = doc.body.children[0]?.textContent || '';
    return t.length > length ? `${t.slice(0, length)}...` : t;
};

export const getElementTitle = element => element.title
    || firstHeaderOrText(element.htmlContent)
    || firstQuestionText(element.questions)
    || '\u00A0';
